module.exports = __webpack_public_path__ + "static/media/delete.0fca542e.svg";